import {
  AccessTime,
  Image,
  LibraryBooks,
  Message,
  MicNone,
  Videocam,
} from "@mui/icons-material";
import React, { memo } from "react";

import { NodeCard, NodeHandle, useNodeStyles } from "./nodeKit";

// O prefixo do item da sequência diz o tipo; a ordem dos testes é a de sempre.
const KINDS = [
  { key: "message", icon: <Message />, field: "value" },
  { key: "interval", icon: <AccessTime />, field: "value", suffix: " segundos" },
  { key: "img", icon: <Image />, field: "original" },
  { key: "audio", icon: <MicNone />, field: "original" },
  { key: "video", icon: <Videocam />, field: "original" },
  { key: "document", icon: <LibraryBooks />, field: "original" },
];

export default memo(({ data, isConnectable, id }) => {
  const classes = useNodeStyles();

  return (
    <NodeCard color="#EC5858" icon={<LibraryBooks />} title="Conteúdo" id={id}>
      <NodeHandle type="target" isConnectable={isConnectable} />
      {data.seq.map((item) =>
        KINDS.filter((kind) => item.includes(kind.key)).map((kind) => (
          <div className={`${classes.slot} ${classes.slotRow}`} key={`${item}-${kind.key}`}>
            {kind.icon}
            <span className={classes.ellipsis}>
              {data.elements.filter((itemLoc) => itemLoc.number === item)[0][kind.field]}
              {kind.suffix || ""}
            </span>
          </div>
        ))
      )}
      <NodeHandle type="source" id="a" isConnectable={isConnectable} />
    </NodeCard>
  );
});
